import { render, staticRenderFns } from "./claim-summary-view.vue?vue&type=template&id=135193e2&"
import script from "./claim-summary-view.vue?vue&type=script&lang=ts&"
export * from "./claim-summary-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports